<template>
  <div class="accounting-main-page">
    <b-tabs card class="custom-tabs">
      <b-tab title="AMOUNT RECEIVABLE" active>
        <AccountingInvoices />
      </b-tab>
      <b-tab title="PAID INVOICES FROM STORE ">
        <PaidInvoices />
      </b-tab>
      <b-tab title="PROCESS PAYROLL">
        <PayrollPage />
      </b-tab>
      <b-tab title="ARCHIVE REPORT">
        <ReportsStoresSaleV2 />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import AccountingInvoices from './AccountingInvoices.vue';
import PaidInvoices from './PaidInvoices.vue';
import PayrollPage from './PayrollPage.vue';
import ReportsStoresSaleV2 from "@/components/Reports/ReportsStoresSaleV2";

export default {
  name: "AccountingMain",
  components: { AccountingInvoices, PaidInvoices, PayrollPage, ReportsStoresSaleV2 },
  created() {
    const userDetails = JSON.parse(localStorage.userDetails || '{}');
    if (userDetails.userrole !== 'admin') {
      localStorage.clear();
      this.$router.push("/");
    }
  }
}
</script>
<style scoped>
.accounting-main-page {
  padding: 20px;
  background: #F6F4F0;
  min-height: 100vh;
}
.page-header {
  margin-bottom: 20px;
}
.page-title {
  font-family: 'Sora', sans-serif;
  font-weight: 700;
  margin: 0;
}
.page-subtitle {
  color: #736C63;
  margin: 4px 0 0;
}
.custom-tabs >>> .nav-tabs {
  border-bottom: 3px solid #E5E1DA;
}
.custom-tabs >>> .nav-tabs .nav-link {
  font-weight: 700;
  color: #736C63;
  border: 1.5px solid #E5E1DA;
  border-bottom: none;
  background: #F7F5F2;
  border-radius: 10px 10px 0 0;
  padding: 12px 24px;
}
.custom-tabs >>> .nav-tabs .nav-link.active {
  background: #221F1C;
  color: #fff;
  border-color: #221F1C;
}
.custom-tabs >>> .tab-content {
  background: #fff;
  border: 1.5px solid #E5E1DA;
  border-top: none;
  border-radius: 0 0 12px 12px;
  padding: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Accounting/AccountingMain.vue